import Api from '@/api/affiliate-api'
import { createLogger } from "@/common/log"

const logger = createLogger("adcell", "", false)
const adcellScript = () => `https://t.adcell.com/js/trad.js`
let adcellObject = {}



const loadScript = (url, defer) => {
  return new Promise((resolve, reject) => {
    const head = document.head || document.getElementsByTagName('head')[0]
    const script = document.createElement('script')
    script.async = true
    script.src = url
    script.id = 'adcell-js'
    script.charset = 'utf-8'
    if (defer) {
      script.setAttribute('defer', 'defer')
    }
    head.appendChild(script)
    script.onload = resolve
    script.onerror = reject
  })
}

const sendUsingImgFallback = url => {
  let adcellFallbackImg = document.createElement('img')
  adcellFallbackImg.id = 'adcellFallbackImg'
  adcellFallbackImg.border = 0
  adcellFallbackImg.height = 0
  adcellFallbackImg.width = 0
  adcellFallbackImg.style = 'display:none'
  adcellFallbackImg.src = url
  adcellFallbackImg.onload = () => {
    //remove it after it has been loaded
    setTimeout(() => {
      adcellFallbackImg.remove()
    }, 500)
  }
  document.body.appendChild(adcellFallbackImg)
}

const adcellOperations = adcell => {
  return {
    setConversionTag: async (cartId, token) => {
      const summaryData = await Api.affiliateSummary(cartId, token)

      let adcellConversion = document.createElement('script')
      adcellConversion.id = 'adcellConversionTag'
      adcellConversion.async = true
      adcellConversion.src = `https://t.adcell.com/t/track.js?pid=${adcell.pid}&eventid=${adcell.eventid}&referenz=${summaryData.id}&betrag=${summaryData.total}`
      document.body.appendChild(adcellConversion)

      sendUsingImgFallback(
        `https://t.adcell.com/t/track?pid=${adcell.pid}&eventid=${adcell.eventid}&referenz=${summaryData.id}&betrag=${summaryData.total}`,
      )
    },
    rerunScript: () => {
      logger.debug('track adcell')
      adcellObject.internal.Tracking.track()
      logger.debug(adcellObject.internal)
      //Adcell.Tracking.track() // eslint-disable-line
    },
  }
}

export default function install(Vue, options = {}) {
  logger.debug('installing adcell')
  let script = loadScript(adcellScript(), false)
  script.then(
    () => {
      logger.debug('adcell installed')
      const windowObject = Adcell || window.Adcell // eslint-disable-line

      if (windowObject) {
        logger.debug('adcell initialized', {id: options.adcell})
        adcellObject = {
          ...adcellOperations(options.adcell),
        }
        adcellObject.internal = windowObject

        adcellObject.internal.Tracking.track()
        //Adcell.Tracking.track() // eslint-disable-line
      }
      Vue.prototype.$adcell = adcellObject
    },
    err => {
      logger.debug('adcell NOT installed', err)
    },
  )
}
